import { Outlet } from "react-router-dom";

const Funcion = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Funcion;
